import { render, staticRenderFns } from "./AvisoPrivacidad.vue?vue&type=template&id=fb34b1ae&scoped=true&"
import script from "./AvisoPrivacidad.vue?vue&type=script&lang=js&"
export * from "./AvisoPrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./AvisoPrivacidad.vue?vue&type=style&index=0&id=fb34b1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb34b1ae",
  null
  
)

export default component.exports